import React from 'react'
import { currencyParser } from 'alelo-logic/utils'

import { posYellow } from 'styles/settings/colors'
import ConsumptionChartBarPos from '../../elements/ConsumptionChartBarPos'
import ConsumptionChartIndicatorPos from '../../elements/ConsumptionChartIndicatorPos'

import {
  IndicatorList,
  IndicatorItem,
  Separator,
  SpentBalance,
  BarInfoContainer,
  Limit
} from './styles'

import { indicatorLabel } from './data.json'

const colors = [posYellow]

const toPercentage = (value, total) => {
  const decimal = value / total
  return decimal * 100
}

// TODO: move to logic
const calculateDataPercentage = (dataArray = [], maxValue) => {
  if (maxValue) {
    return dataArray.map(data => toPercentage(data, maxValue))
  }

  const total = dataArray.reduce((data, nextData) => data + nextData, 0)

  return dataArray.map(data => toPercentage(data, total))
}

const ConsumptionChartPos = ({
  balance = { spending: { toll: 500 } },
  currentPlan,
  accountType
}) => {
  const data = (balance && balance.spending) || {}
  const consumptionTypes = Object.keys(data)
  const dataPercentage = calculateDataPercentage([currentPlan.ammount], currentPlan.limit) || []

  if (accountType && consumptionTypes.length > 2) delete consumptionTypes[0]

  return (
    <section>
      <Separator />
      <ConsumptionChartBarPos colors={colors} values={dataPercentage} />
      <BarInfoContainer>
        <SpentBalance>
          Fatura atual R$ <span>{currencyParser(currentPlan.ammount)}</span>
        </SpentBalance>
        <Limit>
          Limite total R$ <span>{currencyParser(currentPlan.limit)}</span>
        </Limit>
      </BarInfoContainer>

      <IndicatorList>
        {consumptionTypes.map(indicator => (
          <IndicatorItem key={indicator}>
            <ConsumptionChartIndicatorPos
              name={indicatorLabel[indicator]}
              color={posYellow}
              value={currencyParser(data[indicator])}
              indicator={indicator}
              dataPercentage={calculateDataPercentage([data[indicator]], currentPlan.limit)}
            />
          </IndicatorItem>
        ))}
      </IndicatorList>
    </section>
  )
}

export default ConsumptionChartPos



// WEBPACK FOOTER //
// ./src/app/modules/ConsumptionChartPos/index.js